import type { StatusVariantMap } from '@zafroi/ui-kit';

/**
 * Domain → tone dictionaries for the kit's `<StatusBadge />`. Each app owns
 * its own — the kit ships no defaults.
 */

export const leadStatusVariants: StatusVariantMap = {
  new: { label: 'New', tone: 'info' },
  contacted: { label: 'Contacted', tone: 'primary' },
  qualified: { label: 'Qualified', tone: 'accent' },
  follow_up: { label: 'Follow-up', tone: 'warning' },
  converted: { label: 'Converted', tone: 'success' },
  lost: { label: 'Lost', tone: 'neutral' },
};

export const customerLifecycleVariants: StatusVariantMap = {
  prospect: { label: 'Prospect', tone: 'info' },
  active: { label: 'Active', tone: 'success' },
  dormant: { label: 'Dormant', tone: 'warning' },
  churned: { label: 'Churned', tone: 'neutral' },
};

export const conversationStatusVariants: StatusVariantMap = {
  open: { label: 'Open', tone: 'primary' },
  awaiting_customer: { label: 'Awaiting customer', tone: 'accent' },
  awaiting_agent: { label: 'Awaiting agent', tone: 'warning' },
  resolved: { label: 'Resolved', tone: 'success' },
  archived: { label: 'Archived', tone: 'neutral' },
};

export const supportRequestStatusVariants: StatusVariantMap = {
  pending: { label: 'Pending', tone: 'warning' },
  triaged: { label: 'Triaged', tone: 'info' },
  in_progress: { label: 'In progress', tone: 'primary' },
  resolved: { label: 'Resolved', tone: 'success' },
  closed: { label: 'Closed', tone: 'neutral' },
};

export const ticketStatusVariants: StatusVariantMap = {
  open: { label: 'Open', tone: 'primary' },
  in_progress: { label: 'In progress', tone: 'accent' },
  on_hold: { label: 'On hold', tone: 'warning' },
  escalated: { label: 'Escalated', tone: 'destructive' },
  resolved: { label: 'Resolved', tone: 'success' },
  closed: { label: 'Closed', tone: 'neutral' },
};

export const priorityVariants: StatusVariantMap = {
  low: { label: 'Low', tone: 'neutral' },
  medium: { label: 'Medium', tone: 'info' },
  high: { label: 'High', tone: 'warning' },
  urgent: { label: 'Urgent', tone: 'destructive' },
};

export const channelStatusVariants: StatusVariantMap = {
  connected: { label: 'Connected', tone: 'success' },
  disconnected: { label: 'Disconnected', tone: 'neutral' },
  pending: { label: 'Pending', tone: 'warning' },
  error: { label: 'Error', tone: 'destructive' },
};

export const botKnowledgeStatusVariants: StatusVariantMap = {
  draft: { label: 'Draft', tone: 'warning' },
  approved: { label: 'Approved', tone: 'success' },
  archived: { label: 'Archived', tone: 'neutral' },
};

export const channelKindLabel: Record<string, string> = {
  whatsapp: 'WhatsApp',
  portal: 'Portal',
  email: 'Email',
  sms: 'SMS',
  webchat: 'Web chat',
  phone: 'Phone',
};
